import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeProvider, useTheme } from './ThemeContext';
import { GlobalStyles } from './GlobalStyles';
import Home from './pages/Home';
import Admin from './pages/Admin';
import BlogDetail from './pages/BlogDetail';
import ThemeToggle from './components/ThemeToggle';

// Inner component that has access to theme context
const AppContent = () => {
  const { theme } = useTheme();

  return (
    <StyledThemeProvider theme={theme}>
      <GlobalStyles />
      <ThemeToggle />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
      </Routes>
    </StyledThemeProvider>
  );
};

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
